import { render, staticRenderFns } from "./VaPageNotFoundCustom.vue?vue&type=template&id=72687c39&"
import script from "./VaPageNotFoundCustom.vue?vue&type=script&lang=js&"
export * from "./VaPageNotFoundCustom.vue?vue&type=script&lang=js&"
import style0 from "./VaPageNotFoundCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports